const codeInput = {
    code :'',
    isWrong:false,
    expiredTime:null,
    reset:null,
};

export default codeInput;
